// extracted by mini-css-extract-plugin
module.exports = {"root":"_34ab5f7c","link":"_27ea7bcf","image":"_e6f470ae","title":"_4bf3d3e6","placeholder":"_3f7aa5ec"};